import React from "react";
import { Box, Modal, Card } from "@mui/material";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./LinkedToken.module.css";
import { useEffect } from "react";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const LinkedToken = ({ open, handleClose, selectedToken }) => {
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const classes = useStyles();
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Linked token details</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div>
						<div className={cssClasses.tokenNumWrap}>
							{/* <span>Token Number:{" "}</span> */}
							<span>
								{selectedToken.eventTokenId.tokenId.name} (VJ{selectedToken.tokenNumber})
							</span>
						</div>
					</div>
					<Card className={cssClasses.eventWrap} key={selectedToken.upgradedFrom.paymentId}>
						<div className={cssClasses.cardHeader}>
							{/* {selectedToken.paidAmount === selectedToken.amount &&
                                <div className={cssClasses.tokenNumWrap}>
                                    <span>VJ{selectedToken.tokenNumber}</span>
                                </div>
                            } */}
							<div className={cssClasses.tokenNumWrap}>
								{/* <span>Token Number:{" "}</span> */}
								<span>
									{selectedToken.upgradedFrom.eventTokenId.tokenId.name} (VJ{selectedToken.upgradedFrom.tokenNumber})
								</span>
							</div>
							{/* <div className={cssClasses.tokenStatus}>
                                {selectedToken.upgradedFrom.status === 'pending' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'partial' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'active' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'alloted' && !selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'alloted' && selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect &&
                                    <LeadStatusChip
                                        label={'Preselected'}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'refund requested' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'refunded' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#E62E05", backgroundColor: "#FFF4ED" }}
                                    ></LeadStatusChip>}
                                {selectedToken.upgradedFrom.status === 'expired' &&
                                    <LeadStatusChip
                                        label={selectedToken.upgradedFrom.status}
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                                    ></LeadStatusChip>}
                            </div> */}
							<div className={cssClasses.tokenLastUpdate}>
								<ReactTimeAgo
									style={{ fontSize: "1.2rem" }}
									date={selectedToken.upgradedFrom?.last_updated_at ?? selectedToken.upgradedFrom?.created_at}
									locale="en-US"
								/>
							</div>
						</div>
						<div className={cssClasses.cardDetails}>
							<div className={cssClasses.tokenDetails}>
								<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
									{/* <span>Token Title: {" "}</span> */}
									{/* <span>{selectedToken.upgradedFrom.eventTokenId.tokenId.name}</span> */}
									<div>
										{selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect && (
											<span>
												<LeadStatusChip
													label={"Preselect"}
													style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
												></LeadStatusChip>
											</span>
										)}
									</div>
								</div>
								<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
									<div>
										{/* <span>{selectedToken.upgradedFrom.eventTokenId.tokenId.inventoryTypeId.type} |{" "}</span> */}
										<span>{selectedToken.upgradedFrom.eventId.title}</span>
									</div>
									<div>
										{/* <span>{selectedToken.upgradedFrom.eventTokenId.tokenId.inventoryTypeId.type} |{" "}</span> */}
										<span>
											{selectedToken.upgradedFrom.isPrerequisiteUsed && selectedToken.upgradedFrom.status === "active" ? (
												<LeadStatusChip
													label={"Upgraded"}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
												/>
											) : (
												<LeadStatusChip
													label={selectedToken.upgradedFrom.status}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
												/>
											)}
										</span>
									</div>
								</div>
								{selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect && (
									<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
										{/* <span>{selectedToken.upgradedFrom.eventTokenId.tokenId.inventoryTypeId.type} |{" "}</span> */}
										<span>{selectedToken.upgradedFrom.projectDetails}</span>
									</div>
								)}
								<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
									<span>
										Bought on : {new Date(selectedToken.upgradedFrom.created_at).toDateString()},{" "}
										{new Date(selectedToken.upgradedFrom.created_at).toLocaleTimeString([], {
											hour: "2-digit",
											minute: "2-digit",
										})}
									</span>
									{/* <span>Valid Till : {selectedToken.upgradedFrom.validity}</span> */}
								</div>
							</div>
						</div>
						<div className={cssClasses.cardFooter}>
							<div className={cssClasses.totalAmt}>
								<span>Token Amount : </span>
								{/* {selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect &&
                                            <span>₹{' '}{numberWithCommas(500000)}</span>}
                                        {!selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect && */}
								{selectedToken.upgradedFrom.eventTokenId.tokenId.isPriorityPass && (
									<span>
										₹{" "}
										{numberWithCommas(
											selectedToken.upgradedFrom.amount +
												(selectedToken.upgradedFrom.upgradedFrom ? selectedToken.upgradedFrom.upgradedFrom.amount : 0)
										)}
									</span>
								)}
								{!selectedToken.upgradedFrom.eventTokenId.tokenId.isPriorityPass && (
									<span>₹ {numberWithCommas(selectedToken.upgradedFrom.amount)}</span>
								)}
								{/* } */}
							</div>
							<div className={cssClasses.paidAmt}>
								{/* {!selectedToken.upgradedFrom.eventTokenId.tokenId.isPreselect && ( */}
								<>
									<span>Paid Amount : </span>
									{selectedToken.upgradedFrom.eventTokenId.tokenId.isPriorityPass && (
										<span>
											₹{" "}
											{numberWithCommas(
												selectedToken.upgradedFrom.paidAmount +
													(selectedToken.upgradedFrom.upgradedFrom ? selectedToken.upgradedFrom.upgradedFrom.paidAmount : 0)
											)}
										</span>
									)}
									{!selectedToken.upgradedFrom.eventTokenId.tokenId.isPriorityPass && (
										<span>₹ {numberWithCommas(selectedToken.upgradedFrom.paidAmount)}</span>
									)}
								</>
								{/* )} */}
							</div>
						</div>
					</Card>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Close"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default LinkedToken;
